import { render, staticRenderFns } from "./DataSourceManager.vue?vue&type=template&id=06845573&scoped=true&"
import script from "./DataSourceManager.vue?vue&type=script&lang=js&"
export * from "./DataSourceManager.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceManager.vue?vue&type=style&index=0&id=06845573&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06845573",
  null
  
)

export default component.exports